export const arrify = input => (Array.isArray(input) ? input : [input])
